import CustomRoundCheckbox from '@components/formControls/CustomRoundCheckbox'

import { CellInfo } from '../types'

export const NdaCell = (info: CellInfo) => {
  const {
    row: { original: profileData },
    meta: { onChangeNda },
  } = info

  return (
    <CustomRoundCheckbox
      checked={!!profileData.nda}
      onChange={e => onChangeNda(profileData.profileId, e.target?.checked)}
      id="NDA_checkbox"
    />
  )
}
